"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICCEventBusManager = void 0;
var errors_1 = require("../errors");
var ICCEventBusManager = /** @class */ (function () {
    function ICCEventBusManager(newID) {
        this.observeeKey = 'observerableId';
        this.observerKey = 'observerId';
        this.smPrefix = 'state_management:';
        this.instanceID = newID;
        this.eventBus = this.initializeEventBus();
    }
    ICCEventBusManager.getUUID = function () {
        // Simple but if need arise we will enhance it.
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    };
    ICCEventBusManager.getInstance = function () {
        return ICCEventBusManager.instance;
    };
    /**
     * Register each observer with eavent bus. Each observer will provide
     * its own configuration- id and callback and service name it is going to
     * observe.
     * @param observer ObserverCBConfiguration
     */
    ICCEventBusManager.prototype.registerObserver = function (observer) {
        if (this.eventBus.registeredObservers &&
            this.eventBus.registeredObservers.length > 0) {
            // Observers are already intialized
            var currentObservers = this.eventBus.registeredObservers;
            if (this.getObservableCBIndex(this.observerKey, observer.observerId, currentObservers, observer.serviceName) >= 0) {
                // TODO: ERROR - re registering not allowed, this way even we can put
                // uniqueness to each observer registration and handling exceptions.
                // Review it. [ERROR HANDLING]
                throw new errors_1.EventBusError(errors_1.ErrorType.duplicateObserver, "Observer with id- " + observer.observerId + "'+\n                ' and serviceName - " + observer.serviceName + " already exists!!!");
            }
            else {
                // Add to observers
                this.addObserver(observer);
            }
        }
        else {
            // Intialize the observers
            this.eventBus.registeredObservers = [];
            this.addObserver(observer);
        }
    };
    /**
     * Configure each observavble with the event bus. Configuration
     * should provide the unique id and service names for each observavble.
     * @param observerable ObservablesCBConfiguration
     */
    ICCEventBusManager.prototype.configObserverable = function (observerable) {
        // check and intialize the observable
        var currentObservables = this.eventBus.configuredObserverables;
        if (currentObservables && currentObservables.length > 0) {
            // Search if current observable is already configured
            var observeeIndex = this.getObservableCBIndex(this.observeeKey, observerable.observerableId, currentObservables);
            this.addObservee(observerable, observeeIndex);
        }
        else {
            this.eventBus.configuredObserverables = [];
            this.addObservee(observerable, -1);
        }
    };
    /**
     * Called by an observee/observable for passing updated data to the observers.
     * @param observableID string
     * @param serviceName string
     * @param data JSON
     */
    ICCEventBusManager.prototype.notifyObservers = function (observableID, serviceName, data) {
        var currentObserverables = this.eventBus.configuredObserverables || undefined;
        if (serviceName.startsWith(this.smPrefix)) {
            // **** State Management Special ***
            // avoid observee/ observer checks and fail silent
            this.executeCallBacks(serviceName.substring(this.smPrefix.length));
        }
        else if (currentObserverables !== undefined) {
            var currentObeservableIndex = this.getObservableCBIndex(this.observeeKey, observableID, currentObserverables);
            if (currentObeservableIndex === -1) {
                // TODO: observerable is not configured properly
                throw new errors_1.EventBusError(errors_1.ErrorType.serviceCallBeforeConfig, "Observable '+\n                ' with id- " + observableID + "'+\n                ' is not configured with event bus!!!");
            }
            var configServices = currentObserverables[currentObeservableIndex].serviceNames;
            if (configServices.indexOf(serviceName) === -1) {
                // TODO: observerable is not configured properly
                throw new errors_1.EventBusError(errors_1.ErrorType.serviceCallBeforeConfig, "Observable - " + observableID + "'+\n                  ' does not provide service for - " + serviceName + " !!!");
            }
            if (this.eventBus.registeredObservers && this.eventBus.registeredObservers.length > 0) {
                this.executeCallBacks(serviceName, data);
            }
        }
        else {
            // TODO: observerable is not configured properly
            // error handling.
            throw new errors_1.EventBusError(errors_1.ErrorType.namespaceNotFound, "Observables are'+\n            ' not configured with event bus!!!");
        }
    };
    /**
     * Every observer should call this method when unmounting itself.
     * @param obID  string
     */
    ICCEventBusManager.prototype.deregisterObserver = function (obID) {
        var currentObservers = this.eventBus.registeredObservers || undefined;
        if (currentObservers !== undefined) {
            var foundIndex = this.getObservableCBIndex(this.observerKey, obID, currentObservers);
            if (foundIndex > -1 &&
                this.eventBus.registeredObservers) {
                this.eventBus.registeredObservers.splice(foundIndex, 1);
            }
        }
    };
    ICCEventBusManager.prototype.addObservee = function (observee, index) {
        if (this.eventBus.configuredObserverables) {
            if (index > -1) {
                // TODO: observable is configured earlier, should allow registration for more.
                var currentObservable = this.eventBus.configuredObserverables.slice(index, index + 1);
                var currentServiceNames = currentObservable[0].serviceNames || [];
                this.eventBus.configuredObserverables[index].serviceNames =
                    this.arrayCopy(currentServiceNames, observee.serviceNames);
            }
            else {
                this.eventBus.configuredObserverables.push(observee);
            }
        }
    };
    ICCEventBusManager.prototype.addObserver = function (observer) {
        if (observer.serviceName.trim() !== '' && this.eventBus.registeredObservers) {
            this.eventBus.registeredObservers.push(observer);
        }
        else {
            throw new errors_1.EventBusError(errors_1.ErrorType.emptyServiceName, "Observer with id- " + observer.observerId + "'+\n            ' is trying to register with empty service name!!!");
        }
    };
    ICCEventBusManager.prototype.executeCallBacks = function (incomingName, data) {
        var _this = this;
        if (this.eventBus.registeredObservers) {
            this.eventBus.registeredObservers.forEach(function (element) {
                if (element.serviceName === incomingName) {
                    if (data) {
                        element.eventHandler.call(_this, data);
                    }
                    else {
                        element.eventHandler.call(_this);
                    }
                }
            });
        }
    };
    // syncObserverables(){
    // }
    ICCEventBusManager.prototype.getObservableCBIndex = function (key, value, arrayOfObject, service) {
        return arrayOfObject.findIndex(function (element) {
            var isExist = element[key] === value;
            return service ? isExist && element.serviceName === service : isExist;
        });
    };
    ICCEventBusManager.prototype.arrayCopy = function (firstArray, secondArray) {
        secondArray.forEach(function (value) {
            if (!(firstArray.indexOf(value) > -1)) {
                firstArray.push(value);
            }
        });
        return firstArray;
    };
    ICCEventBusManager.prototype.initializeEventBus = function () {
        // TODO: reintialize the event bus from cache
        return {
            id: ICCEventBusManager.getUUID(),
            registeredObservers: [],
            configuredObserverables: [],
        };
    };
    ICCEventBusManager.instance = new ICCEventBusManager(ICCEventBusManager.getUUID());
    return ICCEventBusManager;
}());
exports.ICCEventBusManager = ICCEventBusManager;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/event-bus/ICC/ICCEventBusManager.js
// module id = 1183
// module chunks = 8